import { render, staticRenderFns } from "./comp5.vue?vue&type=template&id=ff3b8612&scoped=true"
import script from "./comp5.vue?vue&type=script&lang=ts"
export * from "./comp5.vue?vue&type=script&lang=ts"
import style0 from "./comp5.vue?vue&type=style&index=0&id=ff3b8612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3b8612",
  null
  
)

export default component.exports